import { render, staticRenderFns } from "./ModalAccess.vue?vue&type=template&id=98b6c9f4&scoped=true&"
import script from "./ModalAccess.vue?vue&type=script&lang=js&"
export * from "./ModalAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6c9f4",
  null
  
)

export default component.exports